(() => {
  function findVariant(product, selectedOptions) {
    return (
      product.variants.find((variant) =>
        selectedOptions.every((value, index) => variant.options[index] === value)
      ) || product.variants[0]
    );
  }

  function findVariantById(product, variantId) {
    return product.variants.find((variant) => Number(variant.id) === Number(variantId)) || null;
  }

  function getCurrentProductOptions(root, product) {
    const formId = root.dataset.productFormId;
    const escapedFormId =
      formId && window.CSS && typeof window.CSS.escape === 'function'
        ? CSS.escape(formId)
        : formId;
    const formVariantInput = escapedFormId ? document.querySelector(`#${escapedFormId} [name="id"]`) : null;
    const formVariantId = Number(formVariantInput?.value || 0);
    const urlVariantId = Number(new URLSearchParams(window.location.search).get('variant') || 0);
    const variant =
      findVariantById(product, formVariantId) ||
      findVariantById(product, urlVariantId) ||
      product.selected_or_first_available_variant ||
      product.variants?.[0];

    return Array.isArray(variant?.options) ? variant.options.slice() : [];
  }

  function layoutSkuRows(scope = document) {
    scope.querySelectorAll('.mutil-varaint-picker-sht__row').forEach((row) => {
      const selects = Array.from(row.querySelectorAll('select'));
      const visibleColumns = Math.min(selects.length, 4) || 1;
      const labelColumn = window.innerWidth <= 749 ? '2.2rem' : '2.4rem';

      row.style.gridTemplateColumns = `${labelColumn} repeat(${visibleColumns}, minmax(0, 1fr))`;

      selects.forEach((select, index) => {
        const rowIndex = Math.floor(index / 4) + 1;
        const colIndex = (index % 4) + 2;
        const mobileWrapper = select.closest('.mvps-mobile-select');
        if (mobileWrapper) {
          mobileWrapper.style.gridRow = String(rowIndex);
          mobileWrapper.style.gridColumn = String(colIndex);
          select.style.gridRow = '';
          select.style.gridColumn = '';
        } else {
          select.style.gridRow = String(rowIndex);
          select.style.gridColumn = String(colIndex);
        }
      });
    });
  }

  function closeMobileDropdowns(scope = document) {
    scope.querySelectorAll('.mvps-mobile-select.is-open').forEach((wrapper) => {
      wrapper.classList.remove('is-open');
      const trigger = wrapper.querySelector('.mvps-mobile-select__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function syncMobileDropdown(select) {
    const wrapper = select.closest('.mvps-mobile-select');
    if (!wrapper) return;

    const triggerLabel = wrapper.querySelector('.mvps-mobile-select__label');
    const selectedOption = select.options[select.selectedIndex];
    if (triggerLabel) {
      triggerLabel.textContent = selectedOption ? selectedOption.textContent : '';
    }

    wrapper.querySelectorAll('.mvps-mobile-select__option').forEach((button) => {
      const active = button.dataset.value === select.value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    updateMobileDropdownHint(wrapper);
  }

  function updateMobileDropdownHint(wrapper) {
    if (!wrapper) return;
    const menu = wrapper.querySelector('.mvps-mobile-select__menu');
    if (!menu) return;

    const canScroll = menu.scrollHeight - menu.clientHeight > 4;
    const reachedBottom = menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 4;
    wrapper.classList.toggle('is-hint-hidden', !canScroll || reachedBottom);
  }

  function enhanceMobileSelect(select) {
    const existingWrapper = select.closest('.mvps-mobile-select');
    if (existingWrapper) {
      const hasLegacySheet =
        existingWrapper.querySelector('.mvps-mobile-select__sheet-header') ||
        existingWrapper.querySelector('.mvps-mobile-select__sheet-title') ||
        existingWrapper.querySelector('.mvps-mobile-select__done');
      const hasCurrentStructure =
        existingWrapper.querySelector('.mvps-mobile-select__trigger') &&
        existingWrapper.querySelector('.mvps-mobile-select__menu');

      if (hasLegacySheet || !hasCurrentStructure) {
        teardownMobileSelect(select);
      } else {
        syncMobileDropdown(select);
        return;
      }
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'mvps-mobile-select';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mvps-mobile-select__trigger';
    trigger.setAttribute('aria-expanded', 'false');

    const label = document.createElement('span');
    label.className = 'mvps-mobile-select__label';

    const chevron = document.createElement('span');
    chevron.className = 'mvps-mobile-select__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML = '&#9662;';

    trigger.append(label, chevron);

    const menu = document.createElement('div');
    menu.className = 'mvps-mobile-select__menu';

    const hint = document.createElement('div');
    hint.className = 'mvps-mobile-select__scroll-hint';
    hint.textContent = 'More options below';

    Array.from(select.options).forEach((option) => {
      const optionButton = document.createElement('button');
      optionButton.type = 'button';
      optionButton.className = 'mvps-mobile-select__option';
      optionButton.dataset.value = option.value;
      optionButton.textContent = option.textContent;

      optionButton.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        closeMobileDropdowns(wrapper.closest('[data-mvps-root]') || document);
      });

      menu.appendChild(optionButton);
    });

    select.parentNode.insertBefore(wrapper, select);
    wrapper.append(trigger, menu, hint);
    wrapper.appendChild(select);
    select.classList.add('is-mobile-enhanced');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const scope = wrapper.closest('[data-mvps-root]') || document;
      const willOpen = !wrapper.classList.contains('is-open');
      closeMobileDropdowns(scope);
      if (willOpen) {
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => updateMobileDropdownHint(wrapper));
      }
    });

    menu.addEventListener('scroll', () => updateMobileDropdownHint(wrapper));
    select.addEventListener('change', () => syncMobileDropdown(select));
    syncMobileDropdown(select);
  }

  function teardownMobileSelect(select) {
    const wrapper = select.closest('.mvps-mobile-select');
    if (!wrapper) return;

    wrapper.parentNode.insertBefore(select, wrapper);
    select.classList.remove('is-mobile-enhanced');
    select.style.gridRow = '';
    select.style.gridColumn = '';
    wrapper.remove();
  }

  function syncMobileSelectEnhancements(scope = document) {
    const isMobile = window.innerWidth <= 749;
    scope.querySelectorAll('.mutil-varaint-picker-sht__row select').forEach((select) => {
      if (isMobile) {
        enhanceMobileSelect(select);
      } else {
        teardownMobileSelect(select);
      }
    });
  }

  function setMessage(root, text, isError = false) {
    const node = root.querySelector('[data-mvps-message]');
    if (!node) return;

    if (!text) {
      node.hidden = true;
      node.textContent = '';
      return;
    }

    node.hidden = false;
    node.textContent = text;
    node.style.color = isError ? '#b42318' : '#027a48';
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  }

  function getActiveCard(root) {
    return root.querySelector('[data-mvps-card].is-active');
  }

  function getPickerItem(root) {
    return root.querySelector('[data-mvps-sku-picker-sht]');
  }

  function getActiveSelectorGroup(root) {
    return getActiveCard(root)?.querySelector('[data-mvps-selectors]') || null;
  }

  function updatePickerGroupLabels(root) {
    const pickerItem = getPickerItem(root);
    const selectorGroup = getActiveSelectorGroup(root);
    if (!pickerItem || !selectorGroup) return;

    const firstRow = selectorGroup.querySelector('.mutil-varaint-picker-sht__row');
    if (!firstRow) return;

    pickerItem.querySelectorAll('[data-mvps-picker-group]').forEach((pickerGroup) => {
      const optionIndex = Number(pickerGroup.dataset.optionIndex || 0);
      const select = firstRow.querySelector(`select[data-option-index="${optionIndex}"]`);
      const currentNode = pickerGroup.querySelector('[data-mvps-picker-current]');
      if (!currentNode) return;

      currentNode.textContent = select?.value ? ` : ${select.value}` : '';
    });
  }

  function updatePrimaryDisplayImage(root, variant) {
    const featuredImage = variant?.featured_image;
    if (!featuredImage?.src) return;

    const mediaGallery =
      document.querySelector(`media-gallery#MediaGallery-${root.dataset.sectionId}`) ||
      document.querySelector(`#ProductInfo-${root.dataset.sectionId} media-gallery`) ||
      document.querySelector('media-gallery');

    if (!mediaGallery) return;

    const firstViewerImage = mediaGallery.querySelector('[id^="Slider-Gallery-"] .product__media-item img');
    if (firstViewerImage) {
      firstViewerImage.src = featuredImage.src;
      firstViewerImage.removeAttribute('srcset');
      firstViewerImage.setAttribute('data-mvps-replaced', 'true');
    }

    const firstThumbnailImage = mediaGallery.querySelector('[id^="GalleryThumbnails-"] .thumbnail-list__item img');
    if (firstThumbnailImage) {
      firstThumbnailImage.src = featuredImage.src;
      firstThumbnailImage.removeAttribute('srcset');
      firstThumbnailImage.setAttribute('data-mvps-replaced', 'true');
    }
  }

  function updateMainProductMedia(root, product) {
    const selectorGroup = getActiveSelectorGroup(root);
    const firstRow = selectorGroup?.querySelector('.mutil-varaint-picker-sht__row');
    if (!firstRow) return;

    const selectedOptions = Array.from(firstRow.querySelectorAll('select')).map((select) => select.value);
    const variant = findVariant(product, selectedOptions);
    updatePrimaryDisplayImage(root, variant);
  }

  function syncPickerGroupState(root) {
    const pickerItem = getPickerItem(root);
    const selectorGroup = getActiveSelectorGroup(root);
    if (!pickerItem) return;

    if (!selectorGroup) {
      pickerItem.hidden = true;
      return;
    }

    pickerItem.hidden = false;
    const firstRow = selectorGroup.querySelector('.mutil-varaint-picker-sht__row');
    if (!firstRow) return;

    pickerItem.querySelectorAll('[data-mvps-picker-group]').forEach((pickerGroup) => {
      const optionIndex = Number(pickerGroup.dataset.optionIndex || 0);
      const select = firstRow.querySelector(`select[data-option-index="${optionIndex}"]`);
      if (!select) return;

      pickerGroup.querySelectorAll('[data-mvps-picker-value]').forEach((button) => {
        const active = button.dataset.value === select.value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });

    updatePickerGroupLabels(root);
  }

  function setActiveCard(root, nextCard) {
    root.querySelectorAll('[data-mvps-card]').forEach((card) => {
      const isActive = card === nextCard;
      card.classList.toggle('is-active', isActive);
      const radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = isActive;
      }
    });
    syncPickerGroupState(root);
  }

  function getActiveBundleItems(root, product) {
    const activeCard = getActiveCard(root);
    if (!activeCard) return [];

    const rows = Array.from(activeCard.querySelectorAll('.mutil-varaint-picker-sht__row'));
    if (rows.length) {
      return rows
        .map((row) => ({
          id: Number(row.querySelector('[data-variant-id]')?.value || 0),
          quantity: 1
        }))
        .filter((item) => item.id > 0);
    }

    const fallbackVariantId = Number(product.selected_or_first_available_variant?.id || product.variants?.[0]?.id || 0);
    if (!fallbackVariantId) return [];

    return [{ id: fallbackVariantId, quantity: 1 }];
  }

  async function addItems(root, items, activeElement) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const payload = { items };

    if (cart?.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = root.dataset.sectionUrl || window.location.pathname;
      if (cart.setActiveElement) {
        cart.setActiveElement(activeElement || document.activeElement);
      }
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Failed to add bundle items');
    }

    const added = await response.json();
    return { added, cart };
  }

  function openCartDrawer(cart, added) {
    if (!cart?.renderContents || !added?.sections) return false;

    if (cart.classList?.contains('is-empty')) {
      cart.classList.remove('is-empty');
    }

    cart.renderContents(added);
    return true;
  }

  document.querySelectorAll('[data-mvps-root]').forEach((root) => {
    const productJson = root.querySelector('[data-mvps-product-json]');
    if (!productJson) return;

    const product = JSON.parse(productJson.textContent);
    const optionCount = product.options.length;
    const addToCartButton = root.querySelector('[data-mvps-add-to-cart]');
    const buyNowButton = root.querySelector('[data-mvps-buy-now]');
    const buyNowAlt = root.querySelector('[data-mvps-buy-now-alt]');

    layoutSkuRows(root);
    syncMobileSelectEnhancements(root);

    root.querySelectorAll('[data-mvps-selectors]').forEach((selectorGroup) => {
      const currentOptions = getCurrentProductOptions(root, product);

      selectorGroup.querySelectorAll('.mutil-varaint-picker-sht__row').forEach((row) => {
        const selects = Array.from(row.querySelectorAll('select')).slice(0, optionCount);
        const variantInput = row.querySelector('[data-variant-id]');

        function syncRow() {
          const selected = selects.map((select) => select.value);
          const variant = findVariant(product, selected);
          if (!variant) return;

          selects.forEach((select, index) => {
            if (variant.options[index] !== undefined) {
              select.value = variant.options[index];
            }
          });

          if (variantInput) variantInput.value = variant.id;
          if (selectorGroup === getActiveSelectorGroup(root)) {
            syncPickerGroupState(root);
            updateMainProductMedia(root, product);
          }
        }

        selects.forEach((select, index) => {
          const nextValue = currentOptions[index];
          if (nextValue && Array.from(select.options).some((option) => option.value === nextValue)) {
            select.value = nextValue;
          }
        });

        selects.forEach((select) => select.addEventListener('change', syncRow));
        syncRow();
      });

      if (selectorGroup === getActiveSelectorGroup(root)) {
        syncPickerGroupState(root);
      }
    });

    getPickerItem(root)?.querySelectorAll('[data-mvps-picker-group]').forEach((pickerGroup) => {
      const optionIndex = Number(pickerGroup.dataset.optionIndex || 0);
      pickerGroup.querySelectorAll('[data-mvps-picker-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const selectorGroup = getActiveSelectorGroup(root);
          const nextValue = button.dataset.value || '';
          if (!selectorGroup) return;

          selectorGroup.querySelectorAll('.mutil-varaint-picker-sht__row').forEach((row) => {
            const select = row.querySelector(`select[data-option-index="${optionIndex}"]`);
            if (!select) return;
            if (Array.from(select.options).some((option) => option.value === nextValue)) {
              select.value = nextValue;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    });

    syncPickerGroupState(root);
    updateMainProductMedia(root, product);

    root.querySelectorAll('[data-mvps-card]').forEach((card) => {
      const radio = card.querySelector('input[type="radio"]');
      if (!radio) return;

      card.addEventListener('click', (event) => {
        if (event.target.closest('.mutil-varaint-picker-sht__selectors')) return;
        setActiveCard(root, card);
        updateMainProductMedia(root, product);
      });

      radio.addEventListener('change', () => {
        setActiveCard(root, card);
        updateMainProductMedia(root, product);
      });
    });

    if (addToCartButton) {
      addToCartButton.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        setMessage(root, '');
        setButtonLoading(addToCartButton, true);

        try {
          const items = getActiveBundleItems(root, product);
          if (!items.length) {
            setMessage(root, 'No bundle items found.', true);
            return;
          }

          const { added, cart } = await addItems(root, items, addToCartButton);
          if (!openCartDrawer(cart, added)) {
            window.location.href = '/cart';
          }
        } catch (error) {
          setMessage(root, 'Something went wrong. Please try again.', true);
        } finally {
          setButtonLoading(addToCartButton, false);
        }
      });
    }

    async function handleBuyNow(event, trigger) {
      event.preventDefault();
      event.stopPropagation();

      setMessage(root, '');
      setButtonLoading(buyNowButton, true);

      try {
        const items = getActiveBundleItems(root, product);
        if (!items.length) {
          setMessage(root, 'No bundle items found.', true);
          return;
        }

        await addItems(root, items, trigger || buyNowButton);
        window.location.href = '/checkout';
      } catch (error) {
        setMessage(root, 'Something went wrong. Please try again.', true);
      } finally {
        setButtonLoading(buyNowButton, false);
      }
    }

    if (buyNowButton) {
      buyNowButton.addEventListener('click', (event) => handleBuyNow(event, buyNowButton));
    }

    if (buyNowAlt) {
      buyNowAlt.addEventListener('click', (event) => handleBuyNow(event, buyNowAlt));
      buyNowAlt.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handleBuyNow(event, buyNowAlt);
        }
      });
    }
  });

  window.addEventListener('resize', () => {
    syncMobileSelectEnhancements();
    layoutSkuRows();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.mvps-mobile-select')) return;
    closeMobileDropdowns();
  });
})();
